import React from "react";
import { NavLink } from "react-router-dom";
import { useAppContext } from "../../context/context";

// Material UI Imports
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import UploadIcon from "@mui/icons-material/Upload";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Divider, Menu, SvgIcon } from "@mui/material";
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

// SVG Imports
import LogoSVG from "@/svgs/pulse_prime_logo.svg?react";
import MonitoringSVG from "@/svgs/monitoring.svg?react";
import SideNavbarMenu from "./components/SideNavbarMenu";

const SideNavbar = () => {
  const { context_state } = useAppContext();

  // State - START --------------------------------------------------------------
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  // State - END ----------------------------------------------------------------

  // Methods - START ------------------------------------------------------------
  const handleClick = (
    event: React.MouseEvent<HTMLLIElement | HTMLDivElement, MouseEvent>
  ) => {
    anchorEl ? setAnchorEl(null) : setAnchorEl(event.currentTarget);
  };
  // Methods - END --------------------------------------------------------------

  return (
    <div className="pulse-side-navbar pulse-bg-color--background-800">
      <div className="title">
        <NavLink to="/" className="pulse-color--primary-500 pulse-mb-2">
          <SvgIcon sx={{ fontSize: "40px" }} children={<LogoSVG />} />
        </NavLink>
      </div>
      <div className="container">
        <div className="list">
          <div
            className="list-item pulse-color--background-100"
            onClick={(e) => handleClick(e)}
            id="basic-nav-item"
            aria-controls={open ? "basic-nav-item" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <SvgIcon children={<MonitoringSVG />} />
            <Menu
              className="side-navbar-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClick}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              id="basic-nav-item"
              slotProps={{
                list: {
                  "aria-labelledby": "basic-nav-item",
                }
              }}
            >
              <p className="side-navbar-menu-label pulse-typography-body-1 pulse-color--background-100">
                Portfolio
              </p>

              <Divider className="side-navbar-menu-divider" />

              <SideNavbarMenu
                label="Portfolio"
                items={[
                  { name: "Balances", link: "/portfolio/balances" },
                  { name: "Blotter", link: "/portfolio/blotter" },
                  { name: "Open Orders", link: "/portfolio/open-orders" },
                  { name: "Overview", link: "/portfolio/overview" },
                  { name: "Positions", link: "/portfolio/positions" },
                  {
                    name: "Position Summary",
                    link: "/portfolio/position-summary",
                  },
                  {
                    name: "Trading Overlay",
                    link: "/portfolio/trading-overlay",
                  },
                ]}
                anchorEl={anchorEl}
                open={open}
                handleClick={handleClick}
              />
            </Menu>
          </div>

          <NavLink
            to="algo-management"
            className={({ isActive }: { isActive: boolean }) =>
              `list-item pulse-color--background-100 ${isActive ? "isActive" : ""
              }`
            }
          >
            <DonutLargeIcon />
          </NavLink>

          <NavLink
            to="alert-manager"
            className={({ isActive }: { isActive: boolean }) =>
              `list-item pulse-color--background-100 ${isActive ? "isActive" : ""
              }`
            }
          >
            <NotificationsActiveIcon />
          </NavLink>

          <NavLink
            to="manual-adjustments"
            className={({ isActive }: { isActive: boolean }) =>
              `list-item pulse-color--background-100 ${isActive ? "isActive" : ""
              }`
            }
          >
            <UploadIcon />
          </NavLink>

          <NavLink
            to="static-price-overrides"
            className={({ isActive }: { isActive: boolean }) =>
              `list-item pulse-color--background-100 ${isActive ? "isActive" : ""
              }`
            }
          >
            <AttachMoneyIcon />
          </NavLink>

        </div>

        {context_state.account.admin && (
          <div className="avatar-list">
            <NavLink
              to="/entity-management"
              className={({ isActive }: { isActive: boolean }) =>
                `list-item pulse-color--background-100 pulse-mb-1 ${isActive ? "isActive" : ""
                }`
              }
            >
              <SwitchAccountIcon />
            </NavLink>

            <NavLink
              to="/role-management"
              className={({ isActive }: { isActive: boolean }) =>
                `list-item pulse-color--background-100 pulse-mb-1${isActive ? "isActive" : ""
                }`
              }
            >
              <VpnKeyIcon />
            </NavLink>

            <NavLink
              to="/strategy-management"
              className={({ isActive }: { isActive: boolean }) =>
                `list-item pulse-color--background-100 ${isActive ? "isActive" : ""
                }`
              }
            >
              <EmojiObjectsIcon />
            </NavLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideNavbar;
